import React, { CSSProperties } from 'react';

interface SvgIconPlusProps {
  style?: CSSProperties;
  color?: string;
}

const SvgIconPlus: React.FC<SvgIconPlusProps> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M11.1429 12.8571H6V11.1429H11.1429V6H12.8571V11.1429H18V12.8571H12.8571V18H11.1429V12.8571Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconPlus;
